// faq
    const accordionContent = document.querySelectorAll(".ar_accordion-content");

    accordionContent.forEach((item, index) => {
        let header = item.querySelector("header");
        header.addEventListener("click", () => {
            item.classList.toggle("open");

            let description = item.querySelector(".ar_description");
            if (item.classList.contains("open")) {
                description.style.height = `${description.scrollHeight}px`;
                item.querySelector(".ar_accordion_title-plus").style.display = "none";
                item.querySelector(".ar_accordion_title-minus").style.display = "block";
            } else {
                description.style.height = "0px";
                item.querySelector(".ar_accordion_title-minus").style.display = "none";
                item.querySelector(".ar_accordion_title-plus").style.display = "block";
            }
            removeOpen(index);
        })
    })

    function removeOpen(index1) {
        accordionContent.forEach((item2, index2) => {
            if (index1 != index2) {
                item2.classList.remove("open");

                let des = item2.querySelector(".ar_description");
                des.style.height = "0px";
                item.querySelector(".ar_accordion_title-minus").style.display = "none";
                item.querySelector(".ar_accordion_title-plus").style.display = "block";
            }
        })
    }




  
// Get the modal Size Popup
var modal = document.getElementById("fl_myModal");

// Get the button that opens the modal
var btn = document.getElementById("fl_size_popup");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("fl_close_section")[0];

// When the user clicks the button, open the modal 
if (btn) {
  btn.onclick = function() {
  modal.style.display = "block";
  }
}


// When the user clicks on <span> (x), close the modal
if (span) {
span.onclick = function() {
  modal.style.display = "none";
}
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
